import { render, staticRenderFns } from "./ClassSearch.vue?vue&type=template&id=d5bcae9a"
import script from "./ClassSearch.vue?vue&type=script&lang=js"
export * from "./ClassSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports